import React from 'react';
import PropTypes from 'prop-types';

import CollectionFee from "./CollectionFee";
import ShowAllTableButton from "./ShowAllTableButton";


class CollectionFeeList extends React.Component {

  state = {
    showAll : false,
    calculateToDate : this.props.calculateToDate    
  };

  constructor(props){
    super(props);
    this.showTableClick = this.showTableClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ calculateToDate: nextProps.calculateToDate });
  }


  showTableClick(showAll){
    this.setState({ showAll: showAll });
  };

  isDateInRange(itemNumber){
    let collectionFees = this.props.data.collectionFee.collectionFeeDates;
    // let calculateToDate = this.props.calculateToDate;
    // console.log("isDateInRange", collectionFees, calculateToDate);

    let item = collectionFees[itemNumber];
    if (itemNumber+1 < collectionFees.length)
    {
      let nextItem = collectionFees[itemNumber+1];
      if ((this.state.calculateToDate < nextItem.validFromDate) && (this.state.calculateToDate >= item.validFromDate)){
        return true;
      }
    }
    else if (this.state.calculateToDate >= item.validFromDate){
      return true;
    }
    return false;
  };

  
  
  render() {    
    // console.log("collectionFees", collectionFees);
    if (!this.props.data.collectionFee){
      return (
        <div></div>
      );
    }

    let collectionFees = this.props.data.collectionFee.collectionFeeDates;
    
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left calc-setting-table-header">Innheimtulaun</th>
            <th className="text-right"><ShowAllTableButton showAll={this.state.showAll} handleShowHideClick={this.showTableClick}/></th>
          </tr>
          </thead>
        </table>
        {collectionFees.map((item,i) => {            
          return(
            <div key={i}>                
              {(!this.state.showAll && this.isDateInRange(i)) && <CollectionFee data={item} transactionKey={this.props.data.collectionFee.transactionKey} highligh={false} />}
              {(this.state.showAll) && <CollectionFee data={item} transactionKey={this.props.data.collectionFee.transactionKey}  highligh={this.isDateInRange(i)} />}
            </div>)
        })}        
      </div>
    );
  }
}

CollectionFeeList.propTypes = {
  data : PropTypes.object,
  calculateToDate: PropTypes.object
};



export default CollectionFeeList;
